import store from '@/store/store'

import i18n from '@/i18n/i18n'
import { apiClient } from '@/services/ApiClient.js'

const { t } = i18n.global

export default {
  login(user) {
    return apiClient
      .post('auth/login', {
        email: user.email,
        password: user.password
      })
      .then(response => {
        if (!response) throw response
        return response
      })
      .catch(error => {
        error = t('shared.auth_errors.credentials_error')

        throw error
      })
  },
  verify(code) {
    return apiClient
      .post('auth/verify', {
        code: code
      })
      .then(response => {
        if (!response) throw response
        return response
      })
      .catch(error => {
        error = t('shared.auth_errors.verification_code_error')

        throw error
      })
  },
  logout() {
    return apiClient
      .get('auth/logout')
      .then(response => {
        return response
      })
      .catch(error => {
        const notification = {
          type: 'danger',
          message: error
        }
        store.dispatch('notification/add', notification)
      })
  },
  getUser() {
    return apiClient
      .get('auth/user')
      .then(response => {
        return response
      })
      .catch(error => {
        throw error
      })
  }
}
